// extracted by mini-css-extract-plugin
export var filterIncDec = "_g9-0";
export var leftBorder = "_g9-1";
export var rightBorder = "_g9-2";
export var stringInput = "_g9-3";